import script from "./CompanyProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyProfile.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyProfile.vue?vue&type=style&index=0&id=07190dc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07190dc8"]])

export default __exports__